export default __webpack_public_path__ + "static/our-rating-background-55cb9c6bfe71f3f599a666e3b0af26ff.png";